<footer class="footer">
    <div class="footer-content">
        <span class="copyright">{{ translations.footer.copyright | translate }}</span>
        <nav class="links">
            <button (click)="openLink('service')">{{ translations.footer.service_contact | translate }}</button>
            <button (click)="openLink('impressum')">{{ translations.footer.impressum | translate }}</button>
            <button (click)="openLink('datenschutz')">{{ translations.footer.datenschutz | translate }}</button>
            <button (click)="openLink('meldestelle')">{{ translations.footer.meldestelle | translate }}</button>
        </nav>
    </div>
    <div class="indicators">
        @if (isDev) {
            <span class="dev-badge">{{ translations.global.is_dev | translate }}</span>
        }
        <span class="version-badge">v{{ environment.version }}</span>
    </div>
</footer>
